import { Link } from 'react-router-dom';
import { formatPhone } from '../lib/format';
import { useTestMode } from '../lib/queries';
import { Icon } from './icons';

/**
 * Kalıcı test modu bandı (PLAN §6.4). Kapatılamaz; canlıya geçilince kaybolur.
 */
export function TestBanner() {
  const testMode = useTestMode();
  const state = testMode.data;

  if (!state || state.runtimeMode === 'LIVE') return null;

  const allowlist = state.allowlist.filter((entry) => entry.active);
  const numbers = allowlist.map((entry) => formatPhone(entry.phone)).join(', ');

  return (
    <div
      role="status"
      className="flex items-center gap-2 border-b border-[#ead9b4] bg-warn-soft px-6 py-1.5 text-[12px] text-warn"
    >
      <Icon name="flask" size={14} className="shrink-0" />
      <span className="font-medium">{state.runtimeMode === 'TEST' ? 'Test modu açık' : 'Pilot mod'}</span>
      <span className="text-warn/90">
        — yalnızca {numbers || 'izin listesindeki numaralara'} yanıt gönderilir; diğer numaralara gönderim guard tarafından engellenir.
      </span>
      <Link to="/test-modu" className="ml-auto shrink-0 font-medium underline underline-offset-2">
        Test Modu
      </Link>
    </div>
  );
}
